import QuoteHeaderBg from "./bg/quotes/header";
import QuoteHeaderDa from "./da/quotes/header";
import QuoteHeaderDe from "./de/quotes/header";
import QuoteHeaderEn from "./en/quotes/header";
import QuoteHeaderEs from "./es/quotes/header";
import QuoteHeaderFi from "./fi/quotes/header";
import QuoteHeaderFr from "./fr/quotes/header";
import QuoteHeaderHr from "./hr/quotes/header";
import QuoteHeaderHu from "./hu/quotes/header";
import QuoteHeaderIt from "./it/quotes/header";
import QuoteHeaderLt from "./lt/quotes/header";
import QuoteHeaderLv from "./lv/quotes/header";
import QuoteHeaderMe from "./me/quotes/header";
import QuoteHeaderMk from "./mk/quotes/header";
import QuoteHeaderNl from "./nl/quotes/header";
import QuoteHeaderPl from "./pl/quotes/header";
import QuoteHeaderRs from "./rs/quotes/header";
import QuoteHeaderSe from "./se/quotes/header";
import QuoteHeaderTr from "./tr/quotes/header";
import QuoteHeaderUs from "./en-us/quotes/header";

export default {
  messages: {
    bg:{QuoteHeader:QuoteHeaderBg},
    da:{QuoteHeader:QuoteHeaderDa},
    de:{QuoteHeader:QuoteHeaderDe},
    en:{QuoteHeader:QuoteHeaderEn},
    'en-us':{QuoteHeader:QuoteHeaderUs},
    es:{QuoteHeader:QuoteHeaderEs},
    fi:{QuoteHeader:QuoteHeaderFi},
    fr:{QuoteHeader:QuoteHeaderFr},
    hr:{QuoteHeader:QuoteHeaderHr},
    hu:{QuoteHeader:QuoteHeaderHu},
    it:{QuoteHeader:QuoteHeaderIt},
    lt:{QuoteHeader:QuoteHeaderLt},
    lv:{QuoteHeader:QuoteHeaderLv},
    me:{QuoteHeader:QuoteHeaderMe},
    mk:{QuoteHeader:QuoteHeaderMk},
    mx:{QuoteHeader:QuoteHeaderEs},
    nl:{QuoteHeader:QuoteHeaderNl},
    pl:{QuoteHeader:QuoteHeaderPl},
    rs:{QuoteHeader:QuoteHeaderRs},
    se:{QuoteHeader:QuoteHeaderSe},
    tr:{QuoteHeader:QuoteHeaderTr},
  },
}
